<template>
    <VBtn :disabled="disabled" color="primary"
          @click="click"
          :style="'min-width: 0px; max-width: 20px; max-height: 25px; ' + ($vuetify.breakpoint.mdAndUp ? 'margin-top: 25px' : '')">
        <VIcon>add</VIcon>
    </VBtn>
</template>

<script>
    export default {
        name: "BotaoAdicionarGrid",
        methods: {
            click(event){
                this.$emit('click', event);
            }
        },
        props: {
            disabled: Boolean
        }
    }
</script>

<style scoped>

</style>
